<template>
  <div
    class="ps-stat-bar"
    :class="{ 'ps-stat-bar--single': isGuideRole }"
  >
    <div
      class="ps-stat-item"
      v-for="item in displayItems"
      :key="item.key"
      :style="item.cardStyle"
    >
      <img class="ps-stat-item__icon" :src="item.icon" alt="" />
      <div class="ps-stat-item__text">
        <div class="ps-stat-item__num" :style="{ color: item.numColor }">
          {{ item.value }}
        </div>
        <div class="ps-stat-item__lbl">{{ item.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getModuleConfig } from "./moduleConfig.js";
import card1 from "@/assets/images/projectShell/stat-card-1.png";
import card2 from "@/assets/images/projectShell/stat-card-2.png";
import card3 from "@/assets/images/projectShell/stat-card-3.png";
import card4 from "@/assets/images/projectShell/stat-card-4.png";
import icon1 from "@/assets/images/projectShell/stat-icon-1.svg";
import icon2 from "@/assets/images/projectShell/stat-icon-2.png";
import icon3 from "@/assets/images/projectShell/stat-icon-3.png";
import icon4 from "@/assets/images/projectShell/stat-icon-4.png";

export default {
  name: "ProjectStatBar",
  props: {
    moduleType: {
      type: String,
      default: "studio",
    },
    /** { total, approved, pending, requests } */
    stats: {
      type: Object,
      default: () => ({
        total: 0,
        approved: 0,
        pending: 0,
        requests: 0,
      }),
    },
  },
  computed: {
    config() {
      return getModuleConfig(this.moduleType);
    },
    /** 教育厅角色仅保留总数卡片 */
    isGuideRole() {
      return this.$store.state.role === "education-guide-role";
    },
    displayItems() {
      const s = this.stats || {};
      const L = this.config.statLabels;
      const items = [
        {
          key: "total",
          label: L.total,
          value: s.total || 0,
          icon: icon1,
          numColor: "#0018ff",
          cardStyle: { backgroundImage: `url(${card1})` },
        },
        {
          key: "approved",
          label: L.approved,
          value: s.approved || 0,
          icon: icon2,
          numColor: "#0e58e5",
          cardStyle: { backgroundImage: `url(${card2})` },
        },
        {
          key: "pending",
          label: L.pending,
          value: s.pending || 0,
          icon: icon3,
          numColor: "#07aa93",
          cardStyle: { backgroundImage: `url(${card3})` },
        },
        {
          key: "requests",
          label: L.requests,
          value: s.requests || 0,
          icon: icon4,
          numColor: "#2aa94a",
          cardStyle: { backgroundImage: `url(${card4})` },
        },
      ];
      // 教育厅角色仅保留总数，不展示 已通过(现行有效)/待审核(含首次申报)/变更请求
      if (this.$store.state.role === "education-guide-role") {
        return items.filter((i) => i.key === "total");
      }
      return items;
    },
  },
};
</script>

<style lang="scss" scoped>
.ps-stat-bar {
  display: flex;
  gap: 4px;
  padding: 0;
  margin-bottom: 8px;
  flex-wrap: wrap;
  background: transparent;
  font-family: "Microsoft YaHei", "微软雅黑", sans-serif;
}
/* 仅展示单张卡片（如教育厅角色只看总数）时，保持卡片原有宽度不被拉伸 */
.ps-stat-bar--single {
  .ps-stat-item {
    flex: 0 1 25%;
    max-width: 25%;
    min-width: 220px;
  }
}
.ps-stat-item {
  flex: 1;
  min-width: 220px;
  height: 115px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 18px 0 28px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;

  &__icon {
    width: 58px;
    height: 58px;
    flex-shrink: 0;
    object-fit: contain;
  }

  &__text {
    margin-left: 16px;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__num {
    font-size: 26px;
    font-weight: 700;
    line-height: 1.1;
    text-align: center;
  }

  &__lbl {
    margin-top: 10px;
    font-size: 15px;
    color: #221815;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@media (max-width: 1100px) {
  .ps-stat-item {
    min-width: calc(50% - 4px);
  }
}
</style>
